<form [formGroup]="form" (submit)="onSubmit()">
  <h1 mat-dialog-title>Add Team Member</h1>
  <div mat-dialog-content class="dialog-padding">
    <p>
      Search existing users by name or email address, or invite a new member by
      email
    </p>
    <mat-form-field>
      <input
        type="text"
        matInput
        placeholder="Name or Email"
        aria-placeholder="Name or Email"
        formControlName="search"
        (input)="update($event.target.value)"
        [matAutocomplete]="auto"
      />
    </mat-form-field>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayName">
      <mat-option *ngFor="let option of searchMatches" [value]="option">
        <div class="option">
          <ca-avatar
            fxFlexAlign="center"
            [image]="option?.profileImage | filedownloadurl"
            [small]="true"
            [fullName]="option | displayname"
          ></ca-avatar>
          <div class="details">
            {{ option | displayname }} ({{ option.email }})
          </div>
        </div>
      </mat-option>
    </mat-autocomplete>
    <ca-role-select
      placeholder="Role"
      formControlName="role"
      [options]="roleOptions"
    ></ca-role-select
    ><br /><br />
  </div>
  <div mat-dialog-actions>
    <button mat-button type="button" (click)="cancel.next()">Cancel</button>
    <button mat-button type="submit" [disabled]="form.invalid">
      {{ form.controls["search"].value?.id ? "Add User" : "Invite User" }}
    </button>
  </div>
</form>
